// src/pages/TermsOfService.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import "./LegalPage.css";

export default function TermsOfService() {
  const { t } = useTranslation();

  return (
    <main className="legal-page">
      <h1 className="legal-page__title">{t('policy.terms.title')}</h1>
      <p className="legal-page__intro">{t('policy.terms.content_intro')}</p>

      {/* 본문 내용 (HTML) */}
      <div className="legal-page__body" dangerouslySetInnerHTML={{ __html: t('policy.terms.body') }} />
    </main>
  );
}
